import * as React from 'react';

//tslint:disable-next-line:no-any
function NoteAndCoinsIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={52.8} height={52.8} viewBox="0 0 52.8 52.8" {...props}>
      <defs>
        <style>{'.prefix__a{fill:#0102ce}'}</style>
      </defs>
      <path
        className="prefix__a"
        // tslint:disable-next-line:max-line-length
        d="M35.785 18.769a17.016 17.016 0 1017.016 17.016 17.035 17.035 0 00-17.016-17.016zm0 15.469a4.629 4.629 0 011.547 9v3.379h-3.094v-3.379a4.633 4.633 0 01-3.094-4.356h3.094a1.547 1.547 0 101.547-1.547 4.629 4.629 0 01-1.547-9v-3.379h3.094v3.379a4.633 4.633 0 013.094 4.356h-3.094a1.547 1.547 0 10-1.547 1.547zM17.222 18.769c9.541 0 17.016-4.077 17.016-9.281S26.763 0 17.222 0 0 4.283 0 9.488s7.681 9.281 17.222 9.281zM0 34.811v2.52c0 5.2 7.681 9.281 17.222 9.281.541 0 1.066-.05 1.6-.076a19.979 19.979 0 01-2.593-6.149C9.328 40.198 3.337 38.077 0 34.811zM15.749 37.253c-.035-.487-.074-.973-.074-1.468a20.022 20.022 0 01.572-4.677C9.338 30.921 3.34 28.799 0 25.53v2.52c0 4.929 6.936 8.801 15.749 9.203z"
      />
      <path
        className="prefix__a"
        // tslint:disable-next-line:max-line-length
        d="M17.222 28.05a20.178 20.178 0 014.345-6.478 34.52 34.52 0 01-4.35.291c-7.344 0-13.723-2.19-17.222-5.614v2.52C0 23.973 7.681 28.05 17.222 28.05z"
      />
    </svg>
  );
}

export default NoteAndCoinsIcon;
